import { ErrorKey } from '../../app-active-error/ErrorKey';
import { EndpointKey } from '../../http/EndpointKey';
import { MetricsCounter } from '../../metrics/MetricsCounter';
import { setError } from '../../store/error/action-creators';
import { getRecaptchaSiteKey, getRecaptchaToken } from '../../store/google-recaptcha/selectors';
import { Tracker } from '../../store/tracking/action-creators';
import { Metrics } from 'I18n/utils/Metrics';
const HandlerConfig = {
  [EndpointKey.Signup]: {
    loggerErrorMessage: '/signup recaptcha error',
    failedTrackerInteraction: 'signup-recaptcha-failed',
    missingInformationTrackerInteraction: 'signup-recaptcha-information-missing',
    metricsCounter: MetricsCounter.RecaptchaSignupError
  },
  [EndpointKey.InitiateVerification]: {
    loggerErrorMessage: '/initiateVerification recaptcha error',
    failedTrackerInteraction: 'initiate-verification-recaptcha-failed',
    missingInformationTrackerInteraction: 'initiate-verification-recaptcha-information-missing',
    metricsCounter: MetricsCounter.RecaptchaInitiateVerificationError
  }
};
export const handleRecaptchaFailed = ({
  state,
  message,
  statusCode,
  LocalLogger,
  endpointKey,
  dispatch,
  metricsCounterDimensions
}) => {
  LocalLogger.error(HandlerConfig[endpointKey].loggerErrorMessage, {
    extra: {
      message,
      statusCode,
      recaptchaToken: getRecaptchaToken(state),
      recaptchaSiteKey: getRecaptchaSiteKey(state)
    }
  });
  dispatch(Tracker.signupInteraction(HandlerConfig[endpointKey].failedTrackerInteraction));
  Metrics.counter(HandlerConfig[endpointKey].metricsCounter, metricsCounterDimensions).increment();
  return dispatch(setError(ErrorKey.RecaptchaCreationError, {
    message
  }));
};
export const handleRecaptchaMissingInformation = ({
  message,
  dispatch,
  endpointKey
}) => {
  dispatch(Tracker.signupInteraction(HandlerConfig[endpointKey].missingInformationTrackerInteraction));
  return dispatch(setError(ErrorKey.RecaptchaMissingInformationError, {
    message
  }));
};